import { AlertBannerModule } from './alert-banner/alert-banner.module';
import { WarnBannerModule } from './warn-banner/warn-banner.module';

export default angular.module('sfMobile.components.banners', [
  AlertBannerModule,
  WarnBannerModule,
]).name;
